import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';
import FuriganaText from './FuriganaText';

/**
 * 言語切り替え（日本語 / English）。
 * i18n.changeLanguage を呼び、選択は i18next-browser-languagedetector の
 * localStorage キャッシュ（key: graphTutor::lang）で永続化される。
 * ボタンのラベルは各言語の自称表記なので翻訳しない。
 */
function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;

  return (
    <div
      role="group"
      aria-label={t('common.language')}
      className={`inline-flex items-center gap-1 rounded-full border p-0.5 ${className}`}
      style={{ borderColor: 'var(--border)', background: 'var(--bg-surface)' }}
    >
      {SUPPORTED_LANGUAGES.map(({ code, label }) => {
        const active = current === code;
        return (
          <button
            key={code}
            type="button"
            lang={code}
            aria-pressed={active}
            onClick={() => i18n.changeLanguage(code)}
            className="rounded-full px-3 py-1 text-sm font-semibold transition-colors"
            style={
              active
                ? { background: 'var(--primary)', color: '#FFFFFF' }
                : { background: 'transparent', color: 'var(--text-muted)' }
            }
          >
            <FuriganaText text={label} />
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
